<template>
  <v-card>
    <v-card-title>
      <span>
        <v-icon>mdi-layers</v-icon> Categoria
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-select
        :items="categories"
        label="Categoria"
        outlined
        v-model="selectedCategory"
      ></v-select>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ArticleCategory',
    data() {
      return {
        categories: [
          'Tech',
          'Greentech'
        ],
        selectedCategory: null
      }
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      selectedCategory(val) {
        this.$store.commit('SET_ARTICLE_CATEGORY', val)
      },
      newArticle: {
        handler(val) {
          this.selectedCategory = val.category
        },
        deep: true
      }
    },
    created() {
      this.selectedCategory = this.newArticle.category
    }
  }
</script>